import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/evidence/')({
  beforeLoad: () => {
    // TanStack Router requires throwing a redirect object (not an Error)
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/evidence/repository', replace: true });
  },
});
